module.exports = __webpack_public_path__ + "static/example_week_columns_with_color_sidebars-ddaf6b324b2d10b2b8d3d2d0890e1755.png";